import { get } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchSubBrands =
  (brands = []) =>
  dispatch =>
    get('/sub-brands', {
      pagination: false,
      selectInBrands: brands,
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(response => {
      dispatch({
        type: types.FETCH_SUBBRANDS,
        payload: {
          subBrands: response['hydra:member'],
        },
      });
      return response['hydra:member'];
    });
